<template>
  <div class="signUp-content" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
    <LittleBanner :attrName="examObj.examName" />
    <div class="sign-content">
      <el-alert
        type="error"
        effect="dark"
        center
      >
        <slot>
          <div class="tip-content">
            <div class="tip-title">填报注意事项</div>
            <div>1.请如实填报所有项目，均为必填项，如无此信息的请填写“无”，谢谢配合。</div>
            <div>2.上传文件的大小均不能超过2MB(2048KB)，如提示文件大小不符，请压缩再后上传。</div>
            <div>
              3.若无法上传照片或保存照片，请升级浏览器后再操作
              <!-- <el-link type="primary">主要链接</el-link> -->
            </div>
          </div>
        </slot>
      </el-alert>
      <div class="form-block">
        <el-form ref="form" :model="form" label-width="180px">
          <el-form-item label="填报岗位" required>
            <el-select v-model="jobId" :disabled="editForm" placeholder="请选择职位" @change="jobChange">
              <el-option
                v-for="(job, index) in examObj.jobs" :key="index"
                :label="job.jobName"
                :value="job.id"
              />
            </el-select>
          </el-form-item>
          <template v-if="formArr.length > 0">
            <el-form-item v-for="(obj, index) in formArr" :key="index" :label="obj.fieldText" :required="obj.requireStatus">
              <form-item :obj="obj" />
            </el-form-item>
          </template>
        </el-form>
        <div class="form-bottom" v-if="formArr.length > 0">
          <el-button type="primary" @click="submitExam">提交审核</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      title="诚信承诺书"
      :visible.sync="dialogVisible"
      width="60%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center>
      <div v-html="examObj.promoseText"></div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" disabled v-if="readTime > 0">阅读须知({{ readTime }})</el-button> -->
        <!-- <el-button type="primary" v-else @click="dialogVisible = false">同意</el-button> -->
        <el-button type="primary" @click="dialogVisible = false">同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { examDetail, getJobForm, signExam, getUserFormData, updateExamForm } from '@/api/exam'
import FormItem from '@/components/FormItem'
import LittleBanner from '../layout/components/LittleBanner'

export default {
  name: 'ExamSignUp',
  components: {
    FormItem,
    LittleBanner
  },
  data() {
    return {
      editForm: false,
      dialogVisible: false,
      readTime: 10,
      loading: false,
      examId: null,
      examineeId: null,
      examObj: {},
      jobId: null,
      form: {
        job: null
      },
      formArr: []
    }
  },
  mounted() {
    let that = this
    this.examId = this.$route.query.examId
    this.getData()
    if (this.$route.query.jobId) {
      this.jobId = Number(this.$route.query.jobId)
      if (this.$route.query.examineeId) {
        this.examineeId = this.$route.query.examineeId
        this.editForm = true
        this.getDefaultData()
      } else {
        this.editForm = false
        this.jobChange()
      }
    }
    let timer = setInterval(function() {
      that.readTime--
      if (timer <=0) {
        clearInterval(timer)
      }
    }, 1000)
  },
  methods: {
    getDefaultData() {
      getUserFormData(this.jobId)
        .then(res => {
          if (res.code === 200) {
            this.formArr = res.data
          }
        })
    },
    getData() {
      examDetail(this.examId)
        .then(res => {
          if (res.code === 200) {
            this.examObj = res.data
            this.dialogVisible = true
          }
        })
    },
    jobChange() {
      this.formArr = []
      getJobForm(this.jobId)
        .then(res => {
          if (res.code === 200) {
            this.formArr = res.data
          }
        })
    },
    submitExam() {
      let arr = []
      let onOff = false
      for (let i = 0; i < this.formArr.length; i++) {
        if (this.formArr[i].requireStatus && !this.formArr[i].value) {
          this.$message.error('请填写' + this.formArr[i].fieldText)
          onOff = true
          break
        }

        if (this.examineeId) {
          if (this.formArr[i].controlName == 'table') {
            let value = this.formArr[i].value
            arr.push({
              id: this.formArr[i].jobFormId,
              value: JSON.stringify(value)
            })
          } else {
            arr.push({
              id: this.formArr[i].jobFormId,
              value: this.formArr[i].value
            })
          }
        } else {
          if (this.formArr[i].controlName == 'table') {
            let value = this.formArr[i].value
            arr.push({
              id: this.formArr[i].id,
              value: JSON.stringify(value)
            })
          } else {
            arr.push({
              id: this.formArr[i].id,
              value: this.formArr[i].value
            })
          }
        }
      }
      if (onOff) {
        return
      }
      this.loading = true
      if (this.examineeId) {
        updateExamForm({
          jobId: this.jobId,
          form: arr
        })
          .then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$alert('提交成功，等待审核', {
                confirmButtonText: '确定',
                callback: () => {
                  this.$router.push('/user')
                }
              })
            }
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        signExam({
          jobId: this.jobId,
          form: arr
        })
          .then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$alert('报名成功，等待审核', {
                confirmButtonText: '确定',
                callback: () => {
                  this.$router.push('/user')
                }
              })
            }
          })
          .catch(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.signUp-content {
  .title {
    color: #000;
    font-weight: 700;
    margin-bottom: 10px;
    font-size: 30px;
    text-align: center;
  }
  .exam-name {
    color: #6c757d;
    text-align: center;
    font-size: 18px;
  }
  .sign-content {
    max-width: 1200px;
    margin: 20px auto;
    box-shadow: 0 0 36px #d8dde5;
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    .tip-content {
      text-align: center;
      line-height: 24px;
      .tip-title {
        font-size: 18px;
      }
    }
    .form-block {
      margin: 20px auto;
      max-width: 800px;
      .form-bottom {
        text-align: center;
      }
    }
  }
}
</style>
